import http from '@/http'

const PATH = '/customers'

function getPath (customerId, number, billingId) {
    return `${PATH}/${customerId}/numbers/${number}/billing/${billingId}`
}

export default {
    async showBilling ({customerId, number, billingId, params}) {
        try {
            const response = await http.get(getPath(customerId, number, billingId), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async updateBilling (data) {
        try {
            const path = getPath(data.customerId, data.number, data.billingId)
            const response = await http.put(
                `${path}/update`,
                data
            )
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async deleteBilling (data) {
        try {
            const path = getPath(data.customerId, data.number, data.billing.id)
            const response = await http.delete(
                `${path}/delete`,
                data
            )
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
}
